import { css } from '@emotion/css';

export const container = (height: string) =>
  css`
    height: ${height};
    align-items: center;
    justify-content: center;
    display: flex;
  `;
